import * as React from 'react'
import { makeStyles, Caption1, tokens, Text } from '@fluentui/react-components'
import {
  Card,
  CardHeader,
  CardPreview,
  CardProps
} from '@fluentui/react-components'
import { useNavigate } from 'react-router-dom'
import Image from '../Image/Image'

type HomeCardProps = CardProps & {
  title?: string
  brandId?: string
  description?: string
  img?: string
  link: string
}

const useStyles = makeStyles({
  card: {
    width: '250px',
    height: '250px',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
    borderRadius: tokens.borderRadiusSmall
  },

  cardPreview: {
    flexGrow: 1,
    minHeight: '60%',
    maxHeight: '70%',
    backgroundColor: 'white'
  },

  cardHeader: {
    padding: '8px',
    flexShrink: 0
  },

  caption: {
    color: tokens.colorNeutralForeground3,
    fontSize: '14px',
    marginTop: '4px',
    textDecoration: 'none !important'
  }
})

const HomeCard: React.FC<HomeCardProps> = (props) => {
  const { link, img, title, description, brandId } = props
  const styles = useStyles()

  const navigate = useNavigate()

  const handleCardClick = () => {
    navigate(`/calculator/${link}`, { state: { brandId: brandId } })
  }

  return (
    <Card
      className={styles.card}
      {...props}
      onClick={handleCardClick}
      selected={false}
    >
      <CardPreview className={styles.cardPreview}>
        <Image base64String={img} />
      </CardPreview>

      <CardHeader
        className={styles.cardHeader}
        header={
          <Text size={500} weight="semibold">
            {title}
          </Text>
        }
        description={
          <Caption1 className={styles.caption}>{description}</Caption1>
        }
      />
    </Card>
  )
}

export default HomeCard
